<template>
  <!-- <div class="ma-5">
    <titleAgency />
    <v-tabs
      v-model="activeTab"
      @change="changeTab()"
      style="margin-top: -48px;"
      background-color="titlebackground"
    >
      <v-tab>อนุมัติคำร้อง</v-tab>
      <v-tab>รับทราบคำร้อง</v-tab>
    </v-tabs>
    <filterAgency :mode="page" v-if="render"/>
    <tableAgency :mode="page" v-if="render"/>
  </div> -->
  <div class="ma-0">
    <titleAgency></titleAgency>
    <v-tabs
      v-model="tab"
      style="margin-top: 0px;"
      color="#2BA197"
      background-color="titlebackground"
    >

    <v-tabs-slider class="ml-2" color="#2BA197"></v-tabs-slider>

    <v-tab v-for="item in items" :key="item.nameBusiness" style="font-weight: 700;font-size: 16px;letter-spacing: 1px;">
      <!-- {{ item }} -->
      <span class="ml-2">{{ item.nameBusiness }}</span>
      <!-- <v-chip
        class="ml-2"
        color="#FEF5E9"
        text-color="#E9A016"
        small
      >
        <span>{{item.count}}</span>
      </v-chip> -->
    </v-tab>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div class="my-0">
          <div>
            <!-- <tableAgency/> -->
            <filterAgency class="mx-5 mt-5"/>
            <tableAgency class="mx-5 mb-5"/>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="my-0">
          <div>
            <filterCompany class="mx-5 mt-5"/>
            <tableCompany class="mx-5 mb-5"/>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</div>
</template>

<script>
import { EventBus } from '@/EventBus'
import titleAgency from '@/components/_manageapprovetoken/_overview/title.vue'
import filterAgency from '@/components/_manageapprovetoken/_overview/filter.vue'
import filterCompany from '@/components/_manageapprovetoken/_overview/filterCompany.vue'
import tableAgency from '@/components/_manageapprovetoken/_overview/table.vue'
import tableCompany from '@/components/_manageapprovetoken/_overview/tableCompany.vue'
export default {
  components: {
    titleAgency,
    filterAgency,
    filterCompany,
    tableAgency,
    tableCompany
  },
  data () {
    return {
      activeTab: 0,
      page: 'approve',
      render: true,
      tab: null,
      items: [
        {
          id: 1,
          nameBusiness: 'บริการที่ใช้งาน',
          count: 1
        },
        {
          id: 1,
          nameBusiness: 'รายการร้องขอที่ใช้บริการ',
          count: 1
        }
      ],
      approveRole: localStorage.approveRole
      // items: [
      //   'ธุรกิจ(ร้านค้า)', 'นิติบุคคล'
      // ]
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.getReqBusinessCount()
  },
  beforeDestroy () {
    EventBus.$off('countManageBusiness')
    EventBus.$off('setApproveRole')
  },
  mounted () {
    // EventBus.$on('countManageBusiness', this.countBusiness)
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  tab: function (val) {
    // EventBus.$emit('CheckTab', val)
    // EventBus.$off('opendialogmember')
    this.forceRerender()
  },
  methods: {
    changeTab (item) {
      this.forceRerender()
    },
    // countBusiness (value) {
    //   this.items = value
    // },
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      await this.getReqBusinessCount()
    },
    forceRerender () {
      if (this.activeTab === 0) {
        this.page = 'approve'
        localStorage.setItem('approveRole', 'Admin')
        EventBus.$emit('updateNavbarRole', 'Admin')
      } else if (this.activeTab === 1) {
        this.page = 'acknowledge'
        localStorage.setItem('approveRole', 'Leader')
        EventBus.$emit('updateNavbarRole', 'Leader')
      }
      this.render = false
      this.$nextTick(() => {
        this.render = true
      })
    },
    async getReqBusinessCount () {
      const obj = {
        role: this.approveRole
      }
      try {
        await this.axios({
          method: 'post',
          url: `${this.api}/api/vMonk/companys/countBusinessAndReqBusiness`,
          data: obj,
          headers: {
            authorization: this.tokenUser
          }
        }).then((response) => {
          if (response.data.success) {
            // this.items = response.data.result.getReqBusiness
            // response.data.result.map((el, index) => {
            //   el.total = el.totalPending
            // })
          } else {
            // console.log(response)
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-tab {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: "600";
  font-size: 1.2rem;
}
</style>
